/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Method_TitleInputs */

const en_fw_bm_method_title = /** @type {(inputs: Fw_Bm_Method_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it is measured`)
};

const id_fw_bm_method_title = /** @type {(inputs: Fw_Bm_Method_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara mengukurnya`)
};

/**
* | output |
* | --- |
* | "How it is measured" |
*
* @param {Fw_Bm_Method_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_method_title = /** @type {((inputs?: Fw_Bm_Method_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Method_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_method_title(inputs)
	return en_fw_bm_method_title(inputs)
});